<template>
  <div>
    <a-modal
      v-if="!isVerified"
      title="找回密码"
      layout="inline"
      :visible="modalVisible"
      :keyboard="false"
      :maskClosable="false"
      destroyOnClose
      @ok="findPassword"
      @cancel="$emit('modal-close')"
    >
      <a-form :form="verifiedForm">
        <!---->
        <a-form-item label="角色：" :label-col="{span:5}" :wrapper-col="{span:15}">
          <a-select
            placeholder="请选择"
            @change="handleRoleChange"
            v-decorator="[
              'TenantId',
              {rules: [{ required: true, message: '请选择角色' }]}
            ]">
            <a-select-option
              v-for="item in roles"
              :value="item.id"
              :key="item.id"
            >{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <!---->
        <a-form-item label="手机" :label-col="{span:5}" :wrapper-col="{span:15}">
          <a-input
            v-decorator="[
              'PhoneNumber',
              {rules: [
                { required: true, message: '请输入您注册时填写的手机号码以找回密码' },
                { pattern:/^1[0-9]{10}$/, message: '请输入正确的手机号码' }
              ]}
            ]"
            placeholder="请输入手机"
          />
        </a-form-item>
        <!---->
        <a-form-item label="验证码" :label-col="{span:5}" :wrapper-col="{span:15}">
          <a-row>
            <a-col :span="15">
              <a-input
                v-decorator="[
                  'CaptchaResponse',
                  {rules: [{ required: true, message: '请输入您收到的验证码' }]}
                ]"
              />
            </a-col>
            <a-col :span="5">
              <a-button
                type="primary"
                placeholder="请输入您收到的验证码"
                :class="vCodeDisabled? 'disabled-btn':'get-code-btn'"
                :disabled="vCodeDisabled"
                @click="ShowGraphCertificateModal"
              >{{ vCodeBtnTips }}
              </a-button>
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      v-else
      title="找回密码"
      layout="inline"
      :visible="modalVisible"
      :keyboard="false"
      :maskClosable="false"
      destroyOnClose
      :footer="null"
      @cancel="$emit('modal-close')"
    >
      <a-table :columns="columns" :data-source="accountList">
        <span slot="action" slot-scope="text">
          <a @click="beforeReset(text)">重置密码</a>
        </span>
      </a-table>
    </a-modal>
    <!-- 重置密码弹窗 -->
    <a-modal
      title="重置密码"
      layout="inline"
      :visible="showReset"
      :keyboard="false"
      :maskClosable="false"
      @ok="resetPassword"
      @cancel="showReset=false"
    >
      <a-form :form="resetPasswordForm">
        <a-form-item label="密码" :label-col="{span:5}" :wrapper-col="{span:15}">
          <a-input
            v-decorator="[
              'password',
              {rules: [{ required: true, message: '请输入您重置的密码' }]}
            ]"
            placeholder="请输入您重置的密码"
            type="password"
          />
        </a-form-item>
        <a-form-item label="确认密码" :label-col="{span:5}" :wrapper-col="{span:15}">
          <a-input
            v-decorator="[
              'passwordAgain',
              {rules: [{ required: true, message: '请再次输入您重置的密码' }]}
            ]"
            placeholder="请再次输入您重置的密码"
            type="password"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 图形验证弹窗 -->
    <GraphCertificateModal ref="GraphCertificateModal" :securityUserCenterUrl="securityUserCenterUrl" :graphCertificateModalVisible="graphCertificateModalVisible" @cancel="graphCertificateModalCancel" @ok="graphCertificateModalOk"></GraphCertificateModal>
  </div>
</template>
<script>
import { getATenantList, SendAliSmsAsync, GetCaptchaAccountByPhone, CheckChangePassCaptcha, ChangePassword } from '@/api/login'
import GraphCertificateModal from '@/components/GraphCertificateModal'
import { setWindowGlobalUrl } from '@/utils/axios'
import { handleUserNameRender } from '@/utils/userCenter'

export default {
  name: 'ForgetModal',
  components: {
    GraphCertificateModal
  },
  props: {
    axios: Function,
    modalVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      securityUserCenterUrl: null,
      graphCertificateModalVisible: false, // 图形验证弹窗
      roles: [],
      tenantId: 2, // 初始化角色-供应商
      vCodeBtnTips: '发送验证码',
      vCodeDisabled: false,
      verifiedForm: this.$form.createForm(this),
      resetPasswordForm: this.$form.createForm(this),
      isVerified: false,
      columns: [
        {
          title: '用户名',
          dataIndex: 'userName',
          key: 'userName',
          customRender: t => handleUserNameRender(t, this.bTenantId)
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      accountList: [],
      showReset: false,
      resetCode: '',
      currentAccount: '',
      phoneNumber: ''
    }
  },
  computed: {
    pathname () {
      return location.pathname
    },
    bTenantId () {
      return this.$route.query.tenantId
    }
  },
  async created () {
    this.getTenant()
    console.log(window.urlConfig && window.urlConfig.requests && window.urlConfig.requests.middlewareUrl);
    if (window.urlConfig && window.urlConfig.requests && window.urlConfig.requests.middlewareUrl) {
      this.securityUserCenterUrl = window.urlConfig.requests.middlewareUrl + '/security/userCenter'
    } else {
      await setWindowGlobalUrl()
      this.securityUserCenterUrl = window.urlConfig.requests.middlewareUrl + '/security/userCenter'
    }
  },

  methods: {
    graphCertificateModalCancel () {
      this.graphCertificateModalVisible = false
    },
    graphCertificateModalOk (graphCode) {
      this.sendVCode(graphCode)
    },
    // 显示图形验证弹窗
    ShowGraphCertificateModal () {
      this.verifiedForm.validateFields(['PhoneNumber', 'TenantId'], async (err, values) => {
        console.log(err)
        if (!err) {
          this.graphCertificateModalVisible = true
          this.$nextTick(() => {
            console.log(this.$refs.GraphCertificateModal)
            this.$refs.GraphCertificateModal.setPhoneNumber(values.PhoneNumber)
          })
        } else {
          this.$message.error('请按要求填写手机号码')
        }
      })
    },
    // 获取角色列表
    async getTenant () {
      const { result } = await getATenantList()
      let roles = []
      roles = result.items.filter((obj) => {
        return obj.name !== 'Default'
      })
      // if (this.pathname === '/sysu/login') {
      //   const specialRoles = [
      //     {
      //       id: 10001,
      //       name: '采购用户',
      //       tenancyName: 'cgr'
      //     },
      //     {
      //       id: 10002,
      //       name: '采购经办人',
      //       tenancyName: 'cgr'
      //     }
      //   ]
      //   // 特殊处理中大的角色选择，将采购人分为采购用户以及采购经办人，但是实际上都是采购人的身份进行登录
      //   this.roles = specialRoles.concat(roles.filter(item => item.name === '代理机构' || item.name === '专家'))
      // } else {
      this.roles = roles.filter(item => item.name === '采购人' || item.name === '供应商' || item.name === '代理机构' || item.name === '专家')
      // }
    },
    handleRoleChange (value) {
      // 特殊处理中大的采购用户（10001）以及采购经办人（10002）
      // if (value === 10001 || value === 10002) {
      //   this.tenantId = 1
      // } else {
      this.tenantId = value
      // }
    },
    sendVCode (graphCode) { // 获取手机验证码
      this.verifiedForm.validateFields(['PhoneNumber', 'TenantId'], async (err, values) => {
        if (!err) {
          if (!this.vCodeDisabled) {
            if (!graphCode) {
              this.$message.error('请先获取图形验证码')
              return
            }
            const parameter = {
              captcha: graphCode,
              phoneNumber: values.PhoneNumber,
              action: 'ChangePassword'
            }
            try {
              let codeRes = await SendAliSmsAsync(parameter)
              if (codeRes.success) {
                codeRes = codeRes.result
                if (codeRes.result.message === 'SUCCESS') {
                  this.$message.success('已发送验证码')
                  this.vCodeDisabled = true
                  let leftTime = 60
                  const iId = setInterval(() => {
                    if (leftTime === 0 || !this.modalVisible) {
                      clearInterval(iId)
                      this.vCodeDisabled = false
                      this.vCodeBtnTips = '发送验证码'
                      return
                    }
                    leftTime--
                    this.vCodeBtnTips = `${leftTime}秒后重发`
                  }, 1000)
                  this.graphCertificateModalVisible = false
                } else {
                  this.$message.error(codeRes.result.message)
                }
              } else {
                this.$message.error(codeRes.error.message)
              }
            } catch (error) {
              console.error(error)
              this.$message.error('发送验证码失败,请检查图形验证码是否输入正确或网络是否正常')
            }
          }
        }
      })
    },
    // 找回密码
    findPassword () {
      this.verifiedForm.validateFields(async (err, values) => {
        if (!err) {
          // // 特殊处理中大的采购用户以及采购经办人角色
          // if (values.TenantId === 10001 || values.TenantId === 10002) {
          //   values.TenantId = 1
          // }
          const { result } = await GetCaptchaAccountByPhone(values)
          if (result.message === '成功') {
            this.phoneNumber = values.PhoneNumber
            this.isVerified = true
            this.resetCode = result.newCode
            this.accountList = Object.values(result.userDics).map((item, index) => {
              return {
                key: index,
                userName: item
              }
            })
            // 特殊处理该平台的数据
            this.accountList = this.accountList.filter(v => {
              return v.userName.toUpperCase() === 'ADMIN' || v.userName.endsWith(`_${this.bTenantId}`)
            })
          } else {
            this.$message.error(result.message)
          }
        }
      })
    },
    beforeReset (e) {
      this.currentAccount = e.userName
      this.showReset = true
    },
    resetPassword () {
      this.resetPasswordForm.validateFields(async (err, values) => {
        if (!err) {
          if (values.password !== values.passwordAgain) {
            this.$message.error('前后输入的密码不一致')
            return
          }
          const checkData = {
            tenantId: this.tenantId,
            userName: this.currentAccount,
            phoneNumber: this.phoneNumber,
            captchaResponse: this.resetCode
          }
          const res = await CheckChangePassCaptcha(checkData)
          if (res.success && res.result.success) {
            const code = res.result.msg
            const changeData = {
              userId: code,
              newPassword: this.resetPasswordForm.getFieldValue('password')
            }
            const res2 = await ChangePassword(changeData) // 找回密码：修改密码
            if (res2.result.success) {
              this.$message.success('密码重置成功')
              this.showReset = false
              this.$emit('modal-close')
              this.isVerified = false
              this.resetPasswordForm.resetFields()
            } else {
              this.$message.error('密码重置失败')
            }
          } else {
            this.$message.error(res.result.msg)
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  /deep/ .ant-modal {
    .get-code-btn {
      background: #1890ff;
      color: #FFF;
      width: 100px;
      margin-left: 5px;
    }

    .disabled-btn {
      background: #AAA;
      border-color: #AAA;
      color: #FFF;
      margin-left: 5px;
    }

    .ant-btn.ant-btn-default:hover {
      color: #FFF !important;
      background: #1890ff !important;
      border-color: #1890ff !important;
    }

    .ant-btn.disabled, .ant-btn[disabled], .ant-btn.disabled:hover, .ant-btn[disabled]:hover, .ant-btn.disabled:focus, .ant-btn[disabled]:focus, .ant-btn.disabled:active, .ant-btn[disabled]:active, .ant-btn.disabled.active, .ant-btn[disabled].active {
      background: #AAA !important;
      border: #AAA !important;
      color: #FFF !important;
    }

    .ant-btn-primary {
      background: #1890ff !important;
      border: #1990ff !important;
    }
  }
</style>
